import React from 'react';
import shallowCompare from 'react-addons-shallow-compare';

class SpinnerIcon extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  render() {
    return (
      <img
        src={require('url-loader!images/spinner@2x.gif')}
        width="24"
        height="24"
      />
    );
  }
}

export default SpinnerIcon;
